/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPPackageEnvironmentVariable,
  ExternalMCPPackageEnvironmentVariable$inboundSchema,
} from "./externalmcppackageenvironmentvariable.js";

/**
 * A published package that runs this server, as declared by the registry
 */
export type ExternalMCPPackage = {
  /**
   * Environment variables the package asks an install to supply. What a server demands — a required secret named here is an approval signal in its own right.
   */
  environmentVariables?:
    | Array<ExternalMCPPackageEnvironmentVariable>
    | undefined;
  /**
   * SHA-256 of the packaged artifact, when the registry publishes one
   */
  fileSha256?: string | undefined;
  /**
   * Package identifier, scope included
   */
  identifier: string;
  /**
   * Registry base URL when the package lives outside the default public registry
   */
  registryBaseUrl?: string | undefined;
  /**
   * Package registry the artifact is published to, such as npm or pypi
   */
  registryType: string;
  /**
   * Launcher the publisher suggests, such as npx or uvx
   */
  runtimeHint?: string | undefined;
  /**
   * Execution transport the package declares, such as stdio
   */
  transportType?: string | undefined;
  /**
   * Published version
   */
  version: string;
};

/** @internal */
export const ExternalMCPPackage$inboundSchema: z.ZodMiniType<
  ExternalMCPPackage,
  unknown
> = z.pipe(
  z.object({
    environment_variables: z.optional(
      z.array(ExternalMCPPackageEnvironmentVariable$inboundSchema),
    ),
    file_sha256: z.optional(z.string()),
    identifier: z.string(),
    registry_base_url: z.optional(z.string()),
    registry_type: z.string(),
    runtime_hint: z.optional(z.string()),
    transport_type: z.optional(z.string()),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "environment_variables": "environmentVariables",
      "file_sha256": "fileSha256",
      "registry_base_url": "registryBaseUrl",
      "registry_type": "registryType",
      "runtime_hint": "runtimeHint",
      "transport_type": "transportType",
    });
  }),
);

export function externalMCPPackageFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPPackage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPPackage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPPackage' from JSON`,
  );
}
